import { render, staticRenderFns } from "./GroupListDetailModal.vue?vue&type=template&id=b59885c0&scoped=true&"
import script from "./GroupListDetailModal.vue?vue&type=script&lang=js&"
export * from "./GroupListDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupListDetailModal.vue?vue&type=style&index=0&id=b59885c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59885c0",
  null
  
)

export default component.exports